import { useState, useEffect } from "react";
import ReactPaginate from "react-paginate";
import { useSelector } from "react-redux";
import { SelectTranslationForm } from "../../../../features/translations/translationsSlice";
import { setcurrentformPage } from "../../../../features/translations/translationsSlice";
import { useDispatch } from "react-redux";
const PaginateItems = (props) => {
  const { itemsPerPage } = props;

  const dispatch = useDispatch();
  const formData = useSelector(SelectTranslationForm);
  
  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);

  useEffect(() => {
    // update current pages on changes in formData
    const endOffset = itemOffset + itemsPerPage;
    dispatch(setcurrentformPage(formData.slice(itemOffset, endOffset)));
    setPageCount(Math.ceil(formData.length / itemsPerPage));
  }, [formData, itemOffset, itemsPerPage, dispatch]);

  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % formData.length;
    setItemOffset(newOffset);
  };

  return (
    <>
      <div className="col-xl-6 col-lg-6 py-4">
        <div className="card">
          <div className="card-header">
            <h4 className="card-title">Translation Form</h4>
          </div>
          <div className="card-body">
            <div className="basic-form">
              <ReactPaginate
                breakLabel="..."
                nextLabel="next >"
                previousLabel="< previous"
                onPageChange={handlePageClick}
                pageCount={pageCount}
                marginPagesDisplayed={3}
                pageRangeDisplayed={1}
                renderOnZeroPageCount={null}
                containerClassName={"pagination"}
                pageClassName={"page-item"}
                pageLinkClassName={"page-link"}
                previousClassName={"page-item"}
                previousLinkClassName={"page-link"}
                nextClassName={"page-item"}
                nextLinkClassName={"page-link"}
                breakClassName={"page-item"}
                breakLinkClassName={"page-link"}
                activeClassName={"active"}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PaginateItems;
